import React,{useCallback}from'react';import PropTypes from'prop-types';import {colors,Icon}from'@manulife/mux';import {useIntl}from'react-intl';import styled from'styled-components';var ValidationErrorShape = process.env.NODE_ENV !== "production" ? PropTypes.shape({
  message: PropTypes.string.isRequired
}) : {};
var CheckList = function CheckList(_ref) {
  var id = _ref.id,
    errors = _ref.errors,
    checkList = _ref.checkList,
    value = _ref.value,
    defaultHidden = _ref.defaultHidden;
  var intl = useIntl();
  var isItemPresent = useCallback(function (itemValue) {
    return function (item) {
      return intl.formatMessage({
        id: item.message
      }) === itemValue;
    };
  }, [intl]);
  var checkIfInError = useCallback(function (itemValue, errList) {
    if (value) {
      return errList === null || errList === void 0 ? void 0 : errList.find(isItemPresent(itemValue));
    }
    return true;
  }, [isItemPresent, value]);
  var showItem = useCallback(function (itemValue, errList, hiddenList) {
    var ifInDefaultHidden = hiddenList === null || hiddenList === void 0 ? void 0 : hiddenList.find(function (element) {
      return element === itemValue;
    });
    return !ifInDefaultHidden || ifInDefaultHidden && (errList === null || errList === void 0 ? void 0 : errList.find(isItemPresent(itemValue)));
  }, [isItemPresent]);
  var List = /*#__PURE__*/styled.ul.withConfig({
    displayName: "CheckList__List",
    componentId: "sc-172nr12-0"
  })(["list-style:none;padding:0px;margin:2px 0px 0px;"]);
  var CheckListItem = /*#__PURE__*/styled.li.withConfig({
    displayName: "CheckList__CheckListItem",
    componentId: "sc-172nr12-1"
  })(["color:", ";margin:0px;font-size:16px;font-weight:300;line-height:24px;span{display:inline-block;vertical-align:middle;width:85%;}"], colors.light_1_dark_navy);
  var CheckListIcon = /*#__PURE__*/styled.i.withConfig({
    displayName: "CheckList__CheckListIcon",
    componentId: "sc-172nr12-2"
  })(["width:23px;height:32px;min-width:23px;padding:0px;background:none;border:none;display:inline-block;vertical-align:middle;text-align:left;"]);
  var CheckButton = function CheckButton() {
    return /*#__PURE__*/React.createElement(CheckListIcon, {
      className: "checklist_btn"
    }, /*#__PURE__*/React.createElement(Icon, {
      width: "0.75rem",
      height: "0.75rem",
      fill: colors.dark_1_green,
      manulifeName: "checkmark"
    }));
  };
  var CloseButton = function CloseButton() {
    return /*#__PURE__*/React.createElement(CheckListIcon, {
      className: "checklist_btn"
    }, /*#__PURE__*/React.createElement(Icon, {
      width: "0.75rem",
      height: "0.75rem",
      fill: colors.light_1_dark_navy,
      manulifeName: "close"
    }));
  };
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    role: "alert"
  }, /*#__PURE__*/React.createElement(List, null, checkList === null || checkList === void 0 ? void 0 : checkList.map(function (item) {
    return showItem(item, errors, defaultHidden) && /*#__PURE__*/React.createElement(CheckListItem, {
      key: "".concat(item)
    }, checkIfInError(item, errors) ? CloseButton() : CheckButton(), /*#__PURE__*/React.createElement("span", null, item));
  })));
};
process.env.NODE_ENV !== "production" ? CheckList.propTypes = {
  id: PropTypes.string,
  errors: PropTypes.arrayOf(ValidationErrorShape).isRequired,
  checkList: PropTypes.arrayOf(PropTypes.string).isRequired,
  value: PropTypes.string.isRequired,
  defaultHidden: PropTypes.arrayOf(PropTypes.string).isRequired
} : void 0;
CheckList.defaultProps = {
  id: 'checklist'
};
var CheckList$1 = CheckList;export{CheckList$1 as default};